import { format } from 'date-fns';


export const dateFormat = (date) => {
    return format(new Date(date), 'dd-MM-yyyy HH:mm')
}

export const dateOnlyFormat = (date) => {
  if (!date) return "";
  return format(new Date(date), 'dd-MM-yyyy');
};


export const to12HourFormat = (time) => {
  if (!time) return "";

  const [hourStr, minuteStr] = time.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr.padStart(2, "0");

  const suffix = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // convert 0 -> 12, 13 -> 1, etc.

  return `${hour}:${minute} ${suffix}`;
}